import { AutocompleteInput, RaRecord, required, useInput } from "react-admin";
import { REWARD_CATEGORY_BY_PLATFORM_AND_DELIVERY_MODE } from "src/lib/rewardCategoryMap";

interface CategoryInputProps {
  isLoading?: boolean;
  formData: any;
}

const CategoryInput: React.FC<CategoryInputProps> = (props) => {
  const { formData, isLoading } = props;
  const { field } = useInput({ source: "item_group" });

  const categoriesByDeliveryMode =
    REWARD_CATEGORY_BY_PLATFORM_AND_DELIVERY_MODE[
      formData.availability_by_service
    ];
  const categoriesForDeliveryMode = formData.delivery_mode
    ? categoriesByDeliveryMode?.[formData.delivery_mode] ?? []
    : [];
  const choices = categoriesForDeliveryMode.map((id) => ({ id, name: id }));

  return (
    <AutocompleteInput
      source="category"
      optionValue="id"
      optionText="name"
      label="Category"
      isOptionEqualToValue={(options: RaRecord, value: RaRecord) => {
        return options.id === value.id;
      }}
      fullWidth
      readOnly={isLoading}
      validate={required()}
      onChange={() => field.onChange(null)}
      choices={choices}
    />
  );
};

export default CategoryInput;
